export default __webpack_public_path__ + "static/media/image1.09170c3b.png";